import request from "./request";

export function getAddress(data) {
  return request(`/services/hpd/api/admin-divisions/${data.provinceGbCode}/${data.cityGbCode}`, "GET");
}